import { render, staticRenderFns } from "./Form8AExport.vue?vue&type=template&id=0037e31a&scoped=true"
import script from "./Form8AExport.vue?vue&type=script&lang=js"
export * from "./Form8AExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0037e31a",
  null
  
)

export default component.exports